import { render, staticRenderFns } from "./TemplateElegantGeneralInfo.vue?vue&type=template&id=42e4a84a&"
import script from "./TemplateElegantGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./TemplateElegantGeneralInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports